export const ImportSource = {
  CLEVER: 'Clever',
  GOOGLE: 'Google',
  CLASSLINK: 'ClassLink',
  UNDEFINED: '',
};

export type ImportSource = (typeof ImportSource)[keyof typeof ImportSource];

export type SyncSource = ImportSource;

export type MergeSource = ImportSource;
